import { makeStyles } from "@material-ui/core/styles";
import { Button, TextButton } from "./Button.js";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  input: {
    display: "none",
  },
  textButton: {
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
}));

export const UploadButton = ({
  accept,
  text,
  onChange,
  loading,
  onlyText,
  labelComponent,
  containerStyle,
  multiple,
  textStyle,
  disabled,
  variant,
  id = "contained-button-file",
  buttonStyle,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} style={containerStyle}>
      <input
        accept={accept}
        className={classes.input}
        id={id}
        type="file"
        onChange={onChange}
        onClick={(event) => {
          event.target.value = null;
        }}
        multiple={multiple}
        disabled={disabled}
      />
      <label htmlFor={id}>
        {labelComponent ? (
          labelComponent
        ) : onlyText ? (
          <TextButton text={text} loading={loading} textStyle={textStyle} disabled={disabled} />
        ) : (
          <Button
            component="span"
            variant={variant}
            text={text}
            loading={loading}
            disabled={disabled}
            buttonStyle={buttonStyle}
          />
        )}
      </label>
    </div>
  );
};
